import { createFileRoute } from "@tanstack/react-router";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { siteConfig } from "@/config";

export const Route = createFileRoute("/terms-condition")({
  head: () => {
    const title = `Terms & Conditions — ${siteConfig.siteName}`;
    const desc = `The terms and conditions that govern use of ${siteConfig.siteName}.`;
    const url = `${siteConfig.domain}/terms-condition`;
    return {
      meta: [
        { title },
        { name: "description", content: desc },
        { property: "og:title", content: title },
        { property: "og:description", content: desc },
        { property: "og:url", content: url },
      ],
      links: [{ rel: "canonical", href: url }],
    };
  },
  component: Terms,
});

function Terms() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="mx-auto max-w-3xl px-4 py-12">
        <h1 className="text-4xl font-bold tracking-tight">Terms &amp; Conditions</h1>
        <div className="prose-article mt-6">
          <p>
            These Terms &amp; Conditions govern your use of {siteConfig.siteName}
            . By accessing the site, you agree to be bound by these terms.
          </p>
          <h2>Editorial content</h2>
          <p>
            All articles, reviews, and buyer's guides on this site are provided
            for informational purposes only. We make reasonable efforts to
            ensure accuracy but do not warrant that content is complete, current,
            or error-free.
          </p>
          <h2>Affiliate relationships</h2>
          <p>
            Some links on this site are affiliate links, meaning we may earn a
            commission if you subscribe to a product through them. Affiliate
            relationships never influence editorial rankings.
          </p>
          <h2>Intellectual property</h2>
          <p>
            All content published on {siteConfig.siteName} is protected by
            copyright and other intellectual property laws. You may share
            excerpts with attribution, but you may not republish full articles
            without written permission.
          </p>
          <h2>Third-party sites</h2>
          <p>
            We link to third-party sites for reference. We are not responsible
            for the content, policies, or practices of those sites.
          </p>
          <h2>Limitation of liability</h2>
          <p>
            To the maximum extent permitted by law, {siteConfig.siteName} is not
            liable for any indirect, incidental, or consequential damages arising
            from your use of this site.
          </p>
          <h2>Changes</h2>
          <p>
            We may update these Terms from time to time. Continued use of the
            site after changes are posted constitutes acceptance of the updated
            Terms.
          </p>
          <h2>Contact</h2>
          <p>
            Questions about these Terms? Email{" "}
            <a href={`mailto:${siteConfig.contactEmail}`}>
              {siteConfig.contactEmail}
            </a>
            .
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
